import angular from 'angular';
import ngMessages from 'angular-messages';
import controller from './assign-controls-to-risk-type-dialog.controller';
import template from './assign-controls-to-risk-type-dialog.html';
import nameMessagesTpl from './name.messages.html';

export class dialogService {
  getOptions($event, {
    riskType,
    controlTypes,
    assetType,
  }) {
    return {
      controller,
      controllerAs: 'assignControlTypeDialogVM',
      locals: {
        riskType,
        controlTypes,
        assetType,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
      bindToController: true,
    };
  }
}

export default angular.module('app.components.global.assignControlsToRiskTypeDialog', [
  ngMessages,
])
  .service('assignControlsToRiskTypeDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('name.messages.html', nameMessagesTpl);
  })
  .name;

console.log('app.components.global.assignControlsToRiskTypeDialog created');
